export const bartOrangeLakeTwelve = [
    [37.79720479635294, -122.26530906502254], // BART Lake Merritt
    [37.79842453699118, -122.26721561503625],
    [37.80039154086281, -122.27199878544107],
    [37.80077691954496, -122.27248936821466],
    [37.80108373504616, -122.27273524337357],
    [37.80171096903121, -122.27267816437488],
    [37.80345615057081, -122.27161724844689], // BART 12th St Oakland
];